import React, { createContext, useContext } from 'react';
import useNavbarStatus from '../hooks/useNavbarStatus';

const NavbarStatusContext = createContext(null);

export function NavbarStatusProvider({ children }) {
  const status = useNavbarStatus();
  return (
    <NavbarStatusContext.Provider value={status}>
      {children}
    </NavbarStatusContext.Provider>
  );
}

export function useNavbarStatusContext() {
  const ctx = useContext(NavbarStatusContext);
  if (!ctx) {
    throw new Error('useNavbarStatusContext must be used within NavbarStatusProvider');
  }
  return ctx;
}
